<template>
    <div v-if="positions !== null">
        <v-data-iterator
            :items="positions.enabledExternalAccounts"
            hide-default-footer
        >
            <template v-slot:default="props">
                <v-row>
                    <v-col
                        v-for="item in props.items"
                        :key="item.account.id"
                        cols="12"
                    >
                        <year-to-date-position :externalAccount="item"/>
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>

        <br />
    </div>
</template>

<script>
import {mapState} from "vuex";
import YearToDatePosition from "./YearToDatePosition";
export default {
    name: "YearToDatePositions",
    components: {YearToDatePosition},
    computed: mapState({
        positions: state => state.household.positions,
    })
}
</script>
